import script from "./CardSquare.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSquare.vue?vue&type=script&setup=true&lang=ts"

import "./CardSquare.vue?vue&type=style&index=0&id=73b12c0e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b12c0e"]])

export default __exports__